/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkAddCustomerSpecificReferenceableSyncEntityRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {BulkAddCustomerSpecificReferenceableSyncEntityResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const bulkAddCustomerSpecificReferenceableSyncEntity = (request: BulkAddCustomerSpecificReferenceableSyncEntityRequest, options?: CashRequestOptions) => post<BulkAddCustomerSpecificReferenceableSyncEntityRequest, BulkAddCustomerSpecificReferenceableSyncEntityResponse>("/2.0/cash/bulk-add-customer-specific-referenceable-sync-entity", request, {...options, rejectOnError: true })